export type StockDisplayQuantity = number | '> 3' | '> 10';

export const calculateDisplayQuantity = (availableQuantity: number): StockDisplayQuantity => {
  if (availableQuantity <= 3) {
    return availableQuantity;
  }

  if (availableQuantity < 10) {
    return '> 3';
  }

  return '> 10';
};

export const isInfiniteStock = (availableQuantity: number): boolean =>
  availableQuantity === Infinity;

export const isLastItem = (availableQuantity: number): boolean => availableQuantity === 1;
